<app-deprecated-confirmation-dialog
    #confirmGenerateRoeReminder
    header="employees.terminate.terminationComplete"
    description="employees.terminate.finalPaymentHasBeenMade"
    label="employees.terminate.remindMeToDoThisLater"
    cancelLabel="employees.terminate.generateTheROE"
></app-deprecated-confirmation-dialog>

<ui-dialog
    size="small"
    [isCloseable]="false"
    header="{{ 'employees.terminate.retroactiveTermination' | translate }}"
    [scrollable]="true"
    (primaryButtonPressed)="shouldMoveToNextStep(); backDatedTerminationDateAffirmed = true; showBackDatedModal = false"
    primaryButtonLabel="{{ 'yesConfirm' | translate }}"
    [open]="showBackDatedModal"
    secondaryButtonLabel="{{ 'cancel' | translate }}"
    [secondaryButtonType]="'ghost'"
    (secondaryButtonPressed)="showBackDatedModal = false"
    (closing)="showBackDatedModal = false"
>
    <p>{{ 'employees.terminate.friendlyReminderLastDayOfWork' | translate }}</p>
    <ui-banner variant="bulb">
        <p [innerHTML]="'employees.terminate.overpaidHelp' | translate"></p>
    </ui-banner>
</ui-dialog>

<ui-confirmation-dialog
    #nextStepsModal
    header="employees.terminate.roeNextStepsHeader"
    primaryButtonLabel="continue"
    secondaryButtonLabel="cancel"
    size="small"
>
    <div [innerHTML]="'employees.terminate.roeNextStepsDescription' | translate"></div>
</ui-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-steps
        #appSteps
        [beforeNext]="shouldMoveToNextStep"
        [steps]="[informationStep, offboardingStep, reviewStep]"
        (onPrimary)="onSave()"
    >
        <app-step
            #informationStep
            step="{{ 'employees.terminate.information' | translate }}"
            [stepForm]="informationForm"
            title="{{ 'employees.terminate.terminationDetails' | translate }}"
        >
            <app-employees-form-terminate-information
                #informationForm
                [employee]="employee"
                [(lastDayOfWorkOn)]="lastDayOfWorkOn"
                [showBenefitExtensionOption]="showBenefitExtensionOption"
                [(benefitExtensionDate)]="benefitExtensionDate"
            >
            </app-employees-form-terminate-information>
        </app-step>

        <app-step
            #offboardingStep
            step="{{ 'employees.terminate.offboarding' | translate }}"
            [stepForm]="offboardingForm"
            title="{{ 'employees.terminate.offboarding' | translate }}"
        >
            <app-employees-form-terminate-offboarding
                #offboardingForm
                [(reminders)]="reminders"
                [(selectedTaskTemplates)]="offboardingTaskTemplates"
                [employee]="employee"
            ></app-employees-form-terminate-offboarding>
        </app-step>

        <app-step
            #reviewStep
            step="{{ 'employees.terminate.review' | translate }}"
            [stepForm]="reviewForm"
            title="{{ 'employees.terminate.review' | translate }}"
        >
            <app-employees-form-terminate-review
                #reviewForm
                [employee]="employee"
                [offboardingReminders]="reminders"
                [hasManagedBenefitPolicy]="hasManagedBenefitPolicy"
                [showBenefitExtensionOption]="showBenefitExtensionOption"
                [benefitExtensionDate]="benefitExtensionDate"
                [isNotProtectedLeave]="informationForm?.isNotProtectedLeave"
                [isNotQuitLeave]="informationForm?.isNotQuitLeave"
                [lastDayOfWorkOn]="lastDayOfWorkOn"
                [lastPaidRecurringPayrollEndDate]="lastPaidRecurringPayrollEndDate"
                [shouldShowBackDatedBanner]="lastDayOfWorkIsBackDated && backDatedTerminationDateAffirmed"
                [employeeIsOnTimeTracking]="employeeIsOnTimeTracking"
            >
            </app-employees-form-terminate-review>
        </app-step>
    </app-steps>
</div>
